<template>
  <div>
    <section-title class="mt-5" has-line title="Información de Vigencia" />
    <div class="row mx-2">
      <div class="col-md-3 col-sm-12">
        <span class="data-label">Año Fiscal:</span>
        <div class="d-flex align-items-center">
          <p class="data">
            {{ value.fiscalYearDescription }}
          </p>
        </div>
      </div>
      <div class="col-md-3 col-sm-12">
        <span class="data-label">Vigencia de Contrato Previo:</span>
        <div class="d-flex align-items-center">
          <p class="data">
            {{ $formatDate(value.orig_EffecteFromDate) }}
            -
            {{ $formatDate(value.orig_EffectiveToDate) }}
          </p>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div v-if="!isReadOnly">
          <div class="data-label">Fecha de Vigencia:</div>
          <div class="d-flex align-items-center mt-1">
            <validation-provider
              v-slot="{ errors }"
              class="mr-2"
              rules="required"
            >
              <custom-date-picker
                v-model="value.effectiveFromDate"
                class="custom-date-picker__extended"
                :custom-error-msg="errorMsg.dateRequired"
                :error="errors[0]"
                :min-date="value.orig_EffectiveToDate"
                :open-date="openDate"
              />
            </validation-provider>
            <span class="mx-1 font-weight-bold">-</span>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-date-picker
                v-model="value.effectiveToDate"
                class="custom-date-picker__extended"
                :custom-error-msg="errorMsg.dateRequired"
                :error="errors[0]"
                :min-date="value.orig_EffectiveToDate"
                :open-date="openDate"
              />
            </validation-provider>
          </div>
        </div>
        <div v-else-if="editing">
          <div class="data-label">Fecha de Vigencia:</div>
          <div class="d-flex align-items-center mt-1">
            <div class="mr-1">
              <custom-date-picker
                v-model="draft.effectiveFromDate"
                class="custom-date-picker__extended"
                :min-date="value.orig_EffectiveToDate"
                :open-date="openDate"
                placeholder="DD/MM/YYYY"
              />
            </div>
            <span class="mx-1 font-weight-bold">-</span>
            <div class="mr-2">
              <custom-date-picker
                v-model="draft.effectiveToDate"
                class="custom-date-picker__extended"
                :min-date="value.orig_EffectiveToDate"
                :open-date="openDate"
                placeholder="DD/MM/YYYY"
              />
            </div>
            <action-button
              class="mr-2 vigency-edit-btn"
              i="fas fa-save"
              title="Guardar"
              variant="outline-success"
              @click="onSave"
            />
            <action-button
              class="vigency-edit-btn"
              i="fas fa-times"
              title="Cancelar"
              variant="outline-secondary"
              @click="onCancel"
            />
          </div>
        </div>
        <div v-else>
          <div class="data-label">Fecha de Vigencia:</div>
          <div class="d-flex align-items-center">
            <p class="data">
              {{ $formatDate(value.effectiveFromDate) }}
              -
              {{ $formatDate(value.effectiveToDate) }}
              <em
                v-if="canEditVigency"
                class="fas fa-edit color-primary-1 ml-1"
                style="cursor: pointer;"
                title="Editar vigencia"
                @click="startEditing"
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDatePicker from 'custom-date-picker';
import SectionTitle from 'SectionTitle';
import moment from 'moment';

export default {
  name: 'ValidityInformation',
  components: {
    CustomDatePicker,
    SectionTitle,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        orig_EffecteFromDate: null,
        orig_EffectiveToDate: null,
        effectiveFromDate: null,
        effectiveToDate: null,
      }),
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    canEditVigency: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      errorMsg: {
        dateRequired: 'Fecha Requerida',
      },
      editing: false,
      draft: {
        effectiveFromDate: null,
        effectiveToDate: null,
      },
    };
  },
  computed: {
    openDate() {
      if (!this.value.orig_EffectiveToDate) return;

      return moment(this.value.orig_EffectiveToDate)
        .add(1, 'days')
        .toDate();
    },
  },
  methods: {
    startEditing() {
      this.draft = {
        effectiveFromDate: this.value.effectiveFromDate,
        effectiveToDate: this.value.effectiveToDate,
      };
      this.editing = true;
    },
    onCancel() {
      this.editing = false;
      this.draft = { effectiveFromDate: null, effectiveToDate: null };
    },
    onSave() {
      this.$emit('save-vigency', { ...this.draft });
    },
    finishEditing() {
      this.editing = false;
      this.draft = { effectiveFromDate: null, effectiveToDate: null };
    },
  },
};
</script>

<style scoped lang="scss">
.custom-date-picker__extended ::v-deep {
  .custom-datetime-picker {
    position: absolute !important;
  }
}

.vigency-edit-btn {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0 !important;
  line-height: 1;
}

.vigency-edit-btn ::v-deep i {
  margin: 0 !important;
  line-height: 1;
}
</style>
